var map = {
	"./argentina/static-text.json": 4014,
	"./australia/static-text.json": 8622,
	"./brazil/static-text.json": 4268,
	"./france/static-text.json": 8139,
	"./germany/static-text.json": 4054,
	"./italy/static-text.json": 2734,
	"./mexico/static-text.json": 1385,
	"./portugal/static-text.json": 1630,
	"./spain/static-text.json": 5462,
	"./testing/static-text.json": 1297,
	"./uk/static-text.json": 9438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8104;